// extracted by mini-css-extract-plugin
export default {"hotspot":"_1tbN39d0nYr3WRpHWsC6Ov","visibleHotspot":"xeqlqaZOm31lzJy4ARCIS"};